import React from 'react';
import styled from 'styled-components';
import OpenAiLogo from '@/assets/OpenAI_Logo.svg';
import ClaudeLogo from '@/assets/Claude_Logo_0.svg';
import GeminiLogo from '@/assets/Google_Gemini_icon_2025.svg';

const LogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const LogoItem = styled.div`
  img {
    height: 24px;
    width: auto;
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover img {
    opacity: 1;
  }
`;

const ProviderLogos: React.FC = () => {
  return (
    <LogosContainer>
      <LogoItem>
        <img src={OpenAiLogo} alt="OpenAI" />
      </LogoItem>
      <LogoItem>
        <img src={ClaudeLogo} alt="Claude" />
      </LogoItem>
      <LogoItem>
        <img src={GeminiLogo} alt="Claude" />
      </LogoItem>
    </LogosContainer>
  );
};

export default ProviderLogos;
